import { render, staticRenderFns } from "./InterfaceForm.vue?vue&type=template&id=083dfafd&scoped=true&"
import script from "./InterfaceForm.vue?vue&type=script&lang=js&"
export * from "./InterfaceForm.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceForm.vue?vue&type=style&index=0&id=083dfafd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083dfafd",
  null
  
)

export default component.exports